import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

@Injectable()
export class MobileLanguageInterceptor implements HttpInterceptor {
  private translate: TranslateService | null = null;

  constructor(private readonly injector: Injector) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.has("Accept-Language") || this.isTranslationAsset(req.url)) {
      return next.handle(req);
    }

    const lang = this.resolveCurrentLang();
    if (!lang) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: { "Accept-Language": lang },
      })
    );
  }

  private resolveCurrentLang(): string | null {
    try {
      if (!this.translate) {
        this.translate = this.injector.get(TranslateService, null, { optional: true });
      }
      return this.translate?.currentLang || this.translate?.defaultLang || null;
    } catch {
      return null;
    }
  }

  private isTranslationAsset(url: string): boolean {
    return /\/assets\/i18n\//i.test(url);
  }
}
